import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-exercise-complete',
    templateUrl: './exercise-complete.component.html',
    styleUrls: ['./exercise-complete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, RouterLink]
})
export class ExerciseCompleteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
